// Globally called Javascript - This file is for non-page specific javascript calls so that they are all called from a single source.
import { GlobalBasketAnalytics } from '../helpers/analytics/GlobalBasketAnalytics';
import JsonPageData from '../helpers/json-page-data'

function initGlobalJS() {
  if(!basketPageMain()) {
    GlobalBasketAnalytics.init();
  }
}

if ('querySelector' in document) {
  ensureDataLayerExists();
  initGlobalJS();
  enhanceNewRelicInformation();
}

// DOM Selectors
function basketPageMain() {
  return document.querySelector( '.view-basket-main' );
}

// Helper
function ensureDataLayerExists() {
  if (typeof window.jlData === 'undefined') {
    window.jlData = {};
  }
}

function enhanceNewRelicInformation() {
  try {
    if (typeof newrelic !== 'object') return;
    let pageData = JsonPageData.getData();
    if (pageData.hasOwnProperty('platform') && !!pageData.platform) {
      newrelic.setCustomAttribute('platform', pageData.platform);
    }
  }
  catch(err) { /* give up */ }
}
